import { DiscountType } from '@wix/auto_sdk_ecom_checkout';
export const getDiscountsToAlignWith = checkout => {
  const {
    appliedDiscounts = [],
    lineItems
  } = checkout;
  let discountsToAlign = [];
  if (!lineItems) {
    return [];
  }
  discountsToAlign = appliedDiscounts.filter(discount => {
    const isSpecificItemDiscountRule = discount.discountType === DiscountType.SPECIFIC_ITEMS && !!discount.discountRule;
    const hasItemsWithMoreThanOneQuantity = lineItems.findIndex(lineItem => new Set(discount.lineItemIds).has(lineItem.id) && lineItem.quantity > 1) > -1;
    return isSpecificItemDiscountRule && hasItemsWithMoreThanOneQuantity;
  });
  return discountsToAlign;
};
export const checkIfItemHasDiscount = (lineItem, discounts) => {
  return discounts.findIndex(discount => new Set(discount.lineItemIds).has(lineItem.id)) > -1;
};
export const getDiscountsValue = function (discounts) {
  if (discounts === void 0) {
    discounts = [];
  }
  return discounts.reduce((accum, discount) => {
    const amount = discount.discountRule.amount.amount || '0';
    return accum + Number(amount);
  }, 0);
};
//# sourceMappingURL=discounts.utils.js.map